<template>
  <b-card-text>
    <div class="d-flex justify-content-between">
      <h5>Приложение № 1</h5>
      <b-button
        @click="predprosmotr = !predprosmotr"
      >
        Предпросмотр
      </b-button>
    </div>

    <div v-if="predprosmotr" class="predprosmotr-card">
      <p class="text-right font-weight-bold">Приложение № 1</p>
      <p class="text-right">к Договору на Транспортно-Экспедиционное Обслуживание № {{ docHistory['typ_dog_teo_exp'].number_of_dogovor || '_____' }} от «{{ docHistory['typ_dog_teo_exp'].day_of_dogovor || '____' }}» {{ docHistory['typ_dog_teo_exp'].month_of_dogovor || '_______________' }} {{ docHistory['typ_dog_teo_exp'].year_of_dogovor || '2025' }} г.</p>
      <p class="text-center font-weight-bold">Заявка №{{ docHistory['typ_dog_teo_exp'].number_request_of_app_1 || '___' }} от «{{ docHistory['typ_dog_teo_exp'].day_request_of_app_1 || '__' }}» {{ docHistory['typ_dog_teo_exp'].month_request_of_app_1 || '_______________' }} {{ docHistory['typ_dog_teo_exp'].year_request_of_app_1 || '2025' }} г.  на организацию транспортно-экспедиционного обслуживания по маршруту: {{ docHistory['typ_dog_teo_exp'].route_of_app_1 || '________________________________________' }}</p>
    </div>

    <b-row class="my-2">
      <b-col cols="3">
        <label class="small-label">Номер заявки</label>
        <b-form-input
          v-model="docHistory['typ_dog_teo_exp'].number_request_of_app_1"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
      <b-col cols="3">
        <label class="small-label">Число заявки</label>
        <b-form-input
          v-model="docHistory['typ_dog_teo_exp'].day_request_of_app_1"
          size="sm"
          trim
          type="number"
        ></b-form-input>
      </b-col>
      <b-col cols="3">
        <label class="small-label">Месяц заявки</label>
        <b-form-input
          v-model="docHistory['typ_dog_teo_exp'].month_request_of_app_1"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
      <b-col cols="3">
        <label class="small-label">Год заявки</label>
        <b-form-input
          v-model="docHistory['typ_dog_teo_exp'].year_request_of_app_1"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row class="my-2">
      <b-col>
        <label class="small-label">Маршрут</label>
        <b-form-input
          v-model="docHistory['typ_dog_teo_exp'].route_of_app_1"
          size="sm"
          trim
        ></b-form-input>
      </b-col>
    </b-row>
  </b-card-text>
</template>

<script>
export default {
  data() {
    return {
      predprosmotr: false,
    }
  },
  props: {
    docHistory: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
  .small-label {
    font-size: 12px;
  }

  .predprosmotr-card {
    padding: 15px;
    margin: 20px 0;
    background: #cccccc59;
  }
</style>